export const IMAGES = {
  AINEXUS: "https://pulsarmoney.b-cdn.net/ainexus/ainexus.png",
  TOKEN_LOGO: "https://pulsarmoney.b-cdn.net/ainexus/a1x-token.png",
  APP_STORE: "https://pulsarmoney.b-cdn.net/ainexus/app-store.png",
  BACKGROUND: "https://pulsarmoney.b-cdn.net/ainexus/background.png",
  CARD_1: "https://pulsarmoney.b-cdn.net/ainexus/card-1.png",
  CARD_CLONE_MACHINE:
    "https://pulsarmoney.b-cdn.net/ainexus/card-clone-machine.png",
  GEMS: "https://pulsarmoney.b-cdn.net/ainexus/coin.png",
  CURRENCY_BANNER: "https://pulsarmoney.b-cdn.net/ainexus/currency-banner.png",
  CURRENCY_CARD: "https://pulsarmoney.b-cdn.net/ainexus/currency-shop-card.png",
  GOLD: "https://pulsarmoney.b-cdn.net/ainexus/currency.png",
  GOOGLE_PLAY: "https://pulsarmoney.b-cdn.net/ainexus/google-play.png",
  STAKE_CONTAINER: "https://pulsarmoney.b-cdn.net/ainexus/stake-container.png",
  SOLANA_LOGO: "https://upload.wikimedia.org/wikipedia/en/b/b9/Solana_logo.png",
  MULTIVERSX_LOGO: "https://pulsarmoney.b-cdn.net/partners/x-mint.png",
  A1X_LOGO:
    "https://tools.multiversx.com/assets-cdn/tokens/A1X-0d446d/icon.svg",
} as const;

export const GEMS_TIERS_IMAGES = {
  TIER_1: "https://pulsarmoney.b-cdn.net/ainexus/currency/credits-1.png",
  TIER_2: "https://pulsarmoney.b-cdn.net/ainexus/currency/credits-2-new.png",
  TIER_3: "https://pulsarmoney.b-cdn.net/ainexus/currency/credits-3.png",
  TIER_4: "https://pulsarmoney.b-cdn.net/ainexus/currency/credits-4.png",
};
export const GOLD_TIERS_IMAGES = {
  TIER_1: "https://pulsarmoney.b-cdn.net/ainexus/currency/gold-1.png",
  TIER_2: "https://pulsarmoney.b-cdn.net/ainexus/currency/gold-2.png",
  TIER_3: "https://pulsarmoney.b-cdn.net/ainexus/currency/gold-3.png",
  TIER_4: "https://pulsarmoney.b-cdn.net/ainexus/currency/gold-4.png",
};

export type ImageKey = keyof typeof IMAGES;
